import React, { useContext } from 'react';
import SHARED from '../../../constants';
import { AdminContext } from '../../../context/AdminContext';
import style from './style.module.css';
import hasFarsiCharacters from '../../../functions/hasFarsiCharacters';
import AppEmojiIcons from '../../../icons/emojiIcons';

export default function MessageTypes({ message, switchToShare, content }) {
  const { themeColor } = useContext(AdminContext);
  // let english = /^[A-Za-z0-9]*$/;
  let english = /[a-zA-Z]/g;
  function hasTags(text) {
    const regex = /<\w+[^>]*>/;
    return regex.test(text);
  }

  return (
    <>
      {message?.typeId == 1 && (
        <div
          className={`${themeColor != 'white' && ''} w-full ${
            hasFarsiCharacters(message?.message) == false &&
            'text-left flex flex-col justify-start ltr maxWidth100'
          } ${style.overflow} `}
          // dangerouslySetInnerHTML={{
          //   __html: `${message?.message

          //     ?.replace(
          //       /(((https?:\/\/)|(www\.))[^\s]+)/g,

          //       "<a class='linkStyle wordBreak flex' rel='noopener noreferrer' href='$1' target='_blank' >$1</a>"
          //     )

          //     ?.replace(/((https?:\/\/www.)|(www\.))/g, ' https://www.')
          //     ?.replace(/\n/g, '<br />')}`,
          // }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {!hasTags(message?.message) ? (
            <div
              dangerouslySetInnerHTML={{
                __html: `${message?.message

                  ?.replace(
                    /(((https?:\/\/)|(www\.))[^\s]+)/g,

                    "<a class='linkStyle wordBreak flex' rel='noopener noreferrer' href='$1' target='_blank' >$1</a>"
                  )

                  ?.replace(/((https?:\/\/www.)|(www\.))/g, ' https://www.')
                  ?.replace(/\n/g, '<br />')}`,
              }}
            ></div>
          ) : (
            <>
              {`${message?.message

                ?.replace(
                  /(((https?:\/\/)|(www\.))[^\s]+)/g,

                  "<a class='linkStyle wordBreak flex' rel='noopener noreferrer' href='$1' target='_blank' >$1</a>"
                )

                ?.replace(/((https?:\/\/www.)|(www\.))/g, ' https://www.')
                ?.replace(/\n/g, '<br />')}`}
            </>
          )}
        </div>
      )}
      {message?.typeId == 3 && (
        <p
          className={`linkStyle`}
          onClick={() => switchToShare(JSON.parse(message?.message))}
        >
          {JSON.parse(message?.message)?.name}
        </p>
      )}
      {message?.typeId == 4 && (
        <a
          className={`linkStyle wordBreak flex`}
          href={`${SHARED?.copy_URL}/video/play/${
            JSON.parse(message?.message)?.uuid
          }`}
          target={`_blank`}
        >
          {`${SHARED?.copy_URL}/video/play/${
            JSON.parse(message?.message)?.uuid
          }`}
        </a>
      )}
      {message?.typeId == 5 && (
        <p
          className={`flex flex-row justify-center items-center w-full h-auto userMessage`}
        >{`${message?.roomUser?.channelUser?.channelName} ${content?.userMessage?.delete}`}</p>
      )}
      {message?.typeId == 6 && (
        <p
          className={`flex flex-row justify-center items-center w-full h-auto userMessage`}
        >{`${message?.roomUser?.channelUser?.channelName} ${content?.userMessage?.left}`}</p>
      )}
      {message?.typeId == 7 && (
        <p
          className={`flex flex-row justify-center items-center w-full h-auto userMessage`}
        >{`${message?.roomUser?.channelUser?.channelName} ${content?.userMessage?.add}`}</p>
      )}
    </>
  );
}
